<footer class="tw:bg-plum tw:px-3 tw:py-7 tw:mt-7">
	<div
		class="tw:mx-auto tw:w-full tw:px-3 tw:bs-sm:max-w-bs-sm tw:bs-md:max-w-bs-md tw:bs-lg:max-w-bs-lg tw:bs-xl:max-w-bs-xl tw:bs-xxl:max-w-bs-xxl">
		<div class="tw:flex tw:*:no-underline">
			<a
				href="/classes"
				class="tw:flex tw:items-center tw:text-lilac tw:hover:text-white"
				title="Class Schedule">
				<svg width="38" height="38" role="img">
					<use href="/images/icons/icons.svg#calendarDayFill" />
				</svg>
				<span class="tw:hidden tw:bs-md:inline tw:ml-3 tw:text-sm">Class<br />Schedule</span>
			</a>

			<a
				href="#locationModal17"
				class="tw:ms-4 tw:text-lilac tw:hover:text-white"
				aria-label="Directions to Strip District">
				<svg width="38" height="38" role="img">
					<use href="/images/icons/icons.svg#geoAltFill" />
				</svg>
			</a>

			<div class="tw:hidden tw:bs-md:inline tw:ml-2 tw:text-sm tw:*:no-underline">
				<a
					href="#locationModal17"
					class="tw:text-lilac tw:hover:text-white"
					title="Directions to Strip District">
					Strip District
				</a><br />
				<a
					href="#locationModal16"
					class="tw:text-lilac tw:hover:text-white"
					title="Directions to North Hills">
					North Hills
				</a>
			</div>

			<a
				href="https://facebook.com/schoolhouseyoga"
				target="_blank"
				rel="noreferrer"
				class="tw:me-4 tw:ms-auto tw:text-lilac tw:hover:text-white"
				aria-label="Facebook">
				<svg width="38" height="38" role="img">
					<use href="/images/logos/logos.svg#facebook" />
				</svg>
			</a>

			<a
				href="https://instagram.com/schoolhouseyoga"
				target="_blank"
				rel="noreferrer"
				class="tw:me-4 tw:text-lilac tw:hover:text-white"
				aria-label="Instagram">
				<svg width="38" height="38" role="img">
					<use href="/images/logos/logos.svg#instagram" />
				</svg>
			</a>

			<a
				href="https://www.youtube.com/watch?v=fxuAnP2GF0I&amp;feature=youtu.be"
				target="_blank"
				rel="noreferrer"
				class="tw:text-lilac tw:hover:text-white"
				aria-label="YouTube">
				<svg width="38" height="38" role="img">
					<use href="/images/logos/logos.svg#youtube" />
				</svg>
			</a>
		</div>

		<div class="tw:text-sm tw:text-lilac tw:mt-4 tw:flex tw:flex-wrap tw:items-center">
			<span class="tw:w-full tw:text-center tw:bs-md:w-auto tw:bs-md:text-start tw:me-auto">
				&copy; {new Date().getFullYear()} Schoolhouse Yoga, Inc. - All Rights Reserved
			</span>

			<div
				class="tw:w-full tw:flex tw:justify-center tw:items-center tw:gap-4 tw:bs-md:w-auto tw:bs-md:justify-end tw:mt-4 tw:bs-md:mt-0 tw:*:no-underline">
				<a href="/privacy" class="tw:text-lilac tw:hover:text-white" title="Privacy Policy">
					Privacy Policy
				</a>
				<a href="/terms" class="tw:text-lilac tw:hover:text-white" title="Terms of Use">
					Terms of Use
				</a>
			</div>
		</div>
	</div>
</footer>
